import {Box, Stack, Tooltip, Typography} from '@mui/material';
import useParseURL from 'hooks/useParseURL';
import {isInProgressState, usePlanOptimization} from 'hooks/usePlanOptimization';
import {URLParams, URLPathname} from 'interfaces';
import {OptimizeIcon} from 'styles/icons';
import {AppTopBarPlansMenu} from './components/AppTopBarPlansMenu';
import {AppTopBarOptimizationProgress} from './components/AppTopBarProgressBars';
import {useTranslation} from 'react-i18next';
import OptimizationButton from 'components/Navigate/AppTopBar/OptimizationButton';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {AppTopBarPlanHistory} from './components/AppTopBarPlanHistory';
import {EMPTY_ID, useGetTenant, useGetMe} from 'hooks/swr';

export const AppTopBarMainPanel = () => {
  const {t} = useTranslation('common');
  const {navigate, planId, language} = useParseURL();
  const {optimizationRun, triggerPlanOptimization} = usePlanOptimization({dontEnqueueSnackbar: false});
  const {newPlanVersions} = useFlags();
  const {data: me} = useGetMe({resourceId: EMPTY_ID});
  const {companyNameEnabledInTopBar} = useFlags();
  // Code Generator Issue
  // eslint-disable-next-line @typescript-eslint/dot-notation
  const {data: myCompany} = useGetTenant({resourceId: me?.tenantId});

  const navigateHome = () => {
    const _urlSearchParams = new URLSearchParams();
    if (language) {
      _urlSearchParams.set(URLParams.language, language);
    }
    navigate({pathname: URLPathname.root, search: _urlSearchParams.toString()});
  };

  return (
    <Stack direction="row" spacing={8.6}>
      <Tooltip title={t('home') ?? ''}>
        <Box
          display="flex"
          alignItems="center"
          onClick={() => {
            navigateHome();
          }}
          sx={{cursor: 'pointer'}}
        >
          <OptimizeIcon color="primary" sx={{mr: 1.4}} />
          <Typography variant="h6" color="textPrimary">
            {t('bioplan')}
          </Typography>
          {companyNameEnabledInTopBar && (
            <Typography color="textPrimary" sx={{paddingLeft: 1}}>
              {myCompany?.name}
            </Typography>
          )}
        </Box>
      </Tooltip>
      <Stack direction="row" spacing={2} alignItems="center">
        <AppTopBarPlansMenu title={t('plans')} />
        {planId && (
          <OptimizationButton optimizationRun={optimizationRun} triggerPlanOptimization={triggerPlanOptimization} />
        )}
        {newPlanVersions ? null : <AppTopBarPlanHistory />}
        {optimizationRun && isInProgressState(optimizationRun.state) && (
          <AppTopBarOptimizationProgress optimizationRun={optimizationRun} />
        )}
      </Stack>
    </Stack>
  );
};
